module.exports = __webpack_public_path__ + "img/image1.7e42e268.png";